import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";

@Component({
  selector: 'app-modal-view-reseau-soin-detail',
  templateUrl: './modal-view-reseau-soin-detail.component.html',
  styleUrls: ['./modal-view-reseau-soin-detail.component.scss']
})
export class ModalViewreseauDeSoinDetailComponent implements OnInit {
  busyGet: Subscription;
  itemToSave: any = {};
  filiale_id:any
  modalRef: BsModalRef;
  user: any = {};
  currentData: any;
  itemsPrestatairereseauDeSoin: any[];

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
  ) {
        this.user = this.authService.getCurrentUser()
        this.filiale_id = this.user.filiale_id

    setTimeout(() => {
      if (this.currentData) {
        this.itemToSave = Object.assign({}, this.currentData);
        this.getItemsReseauDeSoinPrestataire(this.itemToSave.reseau_de_soin_id)
      }
    }, 50);

  }
  
getItemsReseauDeSoinPrestataire(id) {
  this.itemsPrestatairereseauDeSoin=[]
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 10,
    data: {
      reseau_de_soin_id:id
    },
  };

  this.busyGet = this.restClient
    .post("reseauDeSoinPrestataire/getByCriteria", request)
    .subscribe(
      (res) => {
        console.info("itemsFiliale", res);

        if (res && res["items"]) {
          this.itemsPrestatairereseauDeSoin = [...res["items"]]
          
        } else {
          this.itemsPrestatairereseauDeSoin = [];
        }

      },
      (err) => { 
        this.itemsPrestatairereseauDeSoin = [];
      }
    );
}

  ngOnInit() {

 
  }

}
